import { selectConfigurationShoot } from '../../../../../../selectors';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openConfigSlot } from '../../../../../../reducers/productConfigSlice';
import { Box, BoxText } from './SelectedPosesAndBackgroundsStyles';

interface BackgroundSelection {
  image_thumbnail?: string;
}

interface BackgroundSlotProps {
  index: number;
  showLabel?: boolean;
}

// Rendered only for records that carry a background (see BackgroundPosesContainer).
const BackgroundSlot = ({ index, showLabel = false }: BackgroundSlotProps) => {
  const dispatch = useDispatch();
  const backgroundSelections: BackgroundSelection[] = useSelector(
    (state: any) => state.productConfig.backgroundSelections,
  );
  const isGreenScreen = useSelector(
    (state: any) => selectConfigurationShoot(state).isGreenScreen,
  );

  const handleEditBackground = (event: React.MouseEvent) => {
    event.stopPropagation();
    dispatch(openConfigSlot({ slotIndex: index, step: 'background' }));
  };

  if (backgroundSelections.length > 0 && backgroundSelections[index]) {
    return (
      <Box
        isShifted={index > 0}
        background={`url(${backgroundSelections[index]?.image_thumbnail})`}
        onClick={handleEditBackground}
      >
        {showLabel && <BoxText>background</BoxText>}
      </Box>
    );
  }

  // Green-screen shows an empty placeholder tile until a background is chosen.
  if (isGreenScreen) {
    return (
      <Box isShifted={index > 0} onClick={handleEditBackground}>
        {showLabel && <BoxText>background</BoxText>}
      </Box>
    );
  }

  return null;
};

export default BackgroundSlot;
